import $ from "jquery";

import { delay, mergeObjects } from '../../common';
import './autocomplete.css';

$(function() {
  $('.autocomplete-input').on("click", searchAutocomplete);
  $('.autocomplete-input').on("keyup", onChangeAutocompleteValue);
  $('.autocomplete-button').on("click", searchAutocomplete);
});

const onChangeAutocompleteValue = delay(event => searchAutocomplete(event), 500);

$(document).on('click', function () {
  $(".autocomplete-menu").css('display', 'none');
});

const searchAutocomplete = (event) => {
  event.stopPropagation();
  const elem = event.target;
  const id = $(elem).data('id');
  const url = $(elem).data('url');
  const args = $(elem).data('args');
  const value = $(elem).val();

  if (value?.length > 1) {
    var data = mergeObjects({ q: value }, args);

    $.ajax({
      url: url,
      type: "GET",
      dataType: "html",
      data,
      cache: false,
      success: function (data) {
        if (data) {
          $("#" + id + " .autocomplete-menu").css('display', 'block');
          $("#" + id + " .autocomplete-menu").html(data);
        }
      },
      error: function () {
        $("#" + id + " .autocomplete-menu").css('display', 'none');
        $("#" + id + " .autocomplete-menu").html("");
      }
    });
  } else {
    $("#" + id + " .autocomplete-menu").css('display', 'none');
    $("#" + id + " .autocomplete-menu").html("");
  }
};